import React from 'react';
import clsx from 'clsx';
import { ContentDetails } from 'components/WhatsNew/MainList/ContentDetails/ContentDetails';
import { TWhatsNewNotification } from 'lendingApi/whatsNew';
import styles from './SideItem.module.css';

type TProps = {
  data: TWhatsNewNotification;
  onClick: (id: string) => void;
  isSelected: boolean;
};

export const SideItem = ({ isSelected, data, onClick }: TProps) => {
  return (
    <button
      className={clsx(styles.sideItem, { [styles.isSelected]: isSelected })}
      onClick={() => onClick(data.id)}
    >
      <ContentDetails data={data} />
    </button>
  );
};
